module.exports = __webpack_public_path__ + "static/media/close_gray.23f23610.svg";